import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      token: null,
      permissions: [],
      isAuthenticated: false,
      _hasHydrated: false,

      setHasHydrated: (state) => set({ _hasHydrated: state }),

      login: (userData, token, permissions = []) => {
        localStorage.setItem("authToken", token);
        set({ user: userData, token, permissions, isAuthenticated: true });
      },

      logout: () => {
        localStorage.removeItem("authToken");
        set({
          user: null,
          token: null,
          permissions: [],
          isAuthenticated: false,
        });
      },

      setUser: (userData) => set({ user: userData }),
      setPermissions: (permissions) => set({ permissions }),
    }),
    {
      name: "auth-storage",
      onRehydrateStorage: () => (state, error) => {
        if (error) {
          console.error("Error rehydrating auth store:", error);
          return;
        }
        if (state) {
          const token = localStorage.getItem("authToken");
          if (token && state.token) {
            state.isAuthenticated = true;
          } else if (!token) {
            state.isAuthenticated = false;
            state.user = null;
            state.token = null;
            state.permissions = [];
          }
          state._hasHydrated = true;
        }
      },
    }
  )
);
